import React from "react";
import DataTable from "../../table/DataTable";

const ServiceChargeTab = () => {
  const serviceChargeData = [
    {
      country: "United States",
      tierName: "Tier 1",
      tier: "1",
      charge: "$5.00",
    },
    {
      country: "United States",
      tierName: "Tier 2",
      tier: "2",
      charge: "$1.50",
    },
    {
      country: "United States",
      tierName: "Tier 3",
      tier: "3",
      charge: "$10.00",
    },
    { country: "United States", tierName: "Tier 4", tier: "4", charge: "1%" },
    {
      country: "United States",
      tierName: "Tier 5",
      tier: "5",
      charge: "$2.00/month",
    },
  ];

  const serviceChargeColumns = [
    { label: "Country", key: "country", className: "ps-4" },
    { label: "Tier name", key: "tierName", className: "ps-4 fw-bold" },
    { label: "Tier", key: "tier", className: "ps-4 fw-bold" },
    { label: "Service charge", key: "charge", className: "ps-4 fw-bold" },
  ];

  return (
    <DataTable
      data={serviceChargeData}
      columns={serviceChargeColumns}
      showPagination={false}
      minWidth="100%"
    />
  );
};

export default ServiceChargeTab;
